export default __webpack_public_path__ + "static/media/happy_female.5ffc47be.png";